import { Flex, Typography } from 'antd';
import { MInput } from '@Components/Base';

import styles from './fields-styles.module.css';

interface EmailCreationFieldsProps {
  username: string;
  setValues: React.Dispatch<
    React.SetStateAction<{
      password: string;
      username: string;
    }>
  >;
}

const EmailCreationFields: React.FC<EmailCreationFieldsProps> = ({
  setValues,
  username,
}) => {
  return (
    <div className={styles.container}>
      <Flex vertical gap={16}>
        <div>
          <Typography.Text>Email ID / Username:</Typography.Text>
          <MInput
            name="userName"
            value={username}
            onChange={(input) => {
              setValues((prev) => {
                return { ...prev, username: input.target.value };
              });
            }}
            placeholder="Type Username or Email ID"
          />
        </div>

        <div>
          <Typography.Text>Password:</Typography.Text>
          <MInput
            name="password"
            onChange={(input) =>
              setValues((prev) => {
                return { ...prev, password: input.target.value };
              })
            }
            placeholder="Type Password"
          />
        </div>
      </Flex>
    </div>
  );
};

export default EmailCreationFields;
